import React, { ReactNode } from 'react';

import { reducer, initialState } from '../ducks/navigationAdminFilterSlice';
import { NavigationListFiltersContext, NavigationListFiltersDispatchContext } from './NavigationListFiltersContext';

/**
 * Provider to manage the filters of the navigation list.
 * The provider stores the currently set filter and gives a dispatch to update the filter.
 */
export const NavigationListFilterProvider: React.FC<{
    children?: ReactNode;
}> = ({ children }) => {
    /** State for the selected filters */
    const [filters, dispatch] = React.useReducer(reducer, initialState);

    return (
        <NavigationListFiltersContext.Provider value={filters}>
            <NavigationListFiltersDispatchContext.Provider value={dispatch}>
                {children}
            </NavigationListFiltersDispatchContext.Provider>
        </NavigationListFiltersContext.Provider>
    );
};
